import React from 'react'
import classNames from 'classnames'
import {styled} from 'styled-components'

type FormFieldProps = JSX.IntrinsicElements['input'] & {
  label?: string
  error?: string
  hideErrorMessage?: boolean
  style?: React.CSSProperties
}

const FormField = React.forwardRef<HTMLInputElement, FormFieldProps>(({label, error, hideErrorMessage = false, style, ...props}, ref) => {
  return (
    <StyledFormField className={classNames({withError: error != null})} style={style}>
      {label && <label htmlFor={props.name}>{label}</label>}
      <input ref={ref} id={props?.id ?? props?.name} {...props} />
      {error != null && !hideErrorMessage && <div className="field-error">{error}</div>}
    </StyledFormField>
  )
})

export const StyledFormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 13px;

  & label {
    color: #444444;
    margin-bottom: 4px;
  }

  & > input {
    display: block;
    border: 1px solid #eeeeee;
    width: 100%;
    padding: 10px;
    outline: none;
    font-size: 13px;
    border-radius: 6px;
    font-weight: 400;
    color: #373c45;
    box-sizing: border-box;
    margin: 0;
    transition: border-color 0.2s ease, transform 0.2s ease;

    &::placeholder {
      color: #bbbbbb;
    }

    &:focus {
      border-color: #0e78f5;
    }

    &:hover:not(:focus) {
      border-color: #dddddd;
    }

    &:active {
      transform: scale(0.98);
    }
  }

  &.withError {
    & > input {
      border-color: #f64747;
    }
  }

  & .field-error {
    color: #f64747;
    margin-top: 2px;
    text-align: justify;
  }
`

export default FormField
